import React from 'react';
import { string, bool, shape, arrayOf, number } from 'prop-types';
import CopyToClipboard from '@magalu/stereo-ui/molecules/CopyToClipboard';
import Box from '@magalu/stereo-ui/atoms/Box';
import Text from '@magalu/stereo-ui/atoms/Text';
import withLayoutProps from '../../../../../hocs/withLayoutProps';
import useShareLinksEvents from '../../hooks/useShareLinksEvents';
import SocialMedia from '../SocialMedia';
import SharedBag from '../SharedBag';
import ShareLinksActionsSkeleton from './ShareLinksActionsSkeleton';
import ShareLinksActionsError from './ShareLinksActionsError';
import { ContentInfo } from './ShareLinksActions.styles';
var ShareLinksContent = function ShareLinksContent(_ref) {
  var _channel$data$, _channel$data$$value, _structure$config;
  var data = _ref.data,
    linkType = _ref.linkType,
    structure = _ref.structure,
    shortenLink = _ref.shortenLink,
    urlToCopy = _ref.urlToCopy,
    staticProps = _ref.staticProps;
  var channel = data.channel,
    product = data.product;
  var _ref2 = staticProps || {},
    device = _ref2.device,
    sectionSharedBag = _ref2.sectionSharedBag,
    sectionSocial = _ref2.sectionSocial;
  var isDesktop = device === 'desktop';
  var _useShareLinksEvents = useShareLinksEvents({
      isDesktop: isDesktop,
      structure: structure
    }),
    handleAddToReadyBagEvent = _useShareLinksEvents.handleAddToReadyBagEvent,
    handleCopyLinkEvent = _useShareLinksEvents.handleCopyLinkEvent;
  if (shortenLink.isLoading) {
    return React.createElement(ShareLinksActionsSkeleton, {
      isDesktop: isDesktop
    });
  }
  if (shortenLink.hasError) {
    return React.createElement(ShareLinksActionsError, {
      errorStatus: shortenLink.error.status
    });
  }
  return React.createElement(ContentInfo, {
    "data-testid": "share-links-actions"
  }, isDesktop && React.createElement(Box, null, React.createElement(Text, {
    fontSize: 1,
    fontWeight: "regular",
    mb: 2
  }, "Link do produto"), React.createElement(Box, {
    onClick: function onClick() {
      return handleCopyLinkEvent({
        linkType: linkType,
        shareAction: 'copiar-link'
      });
    },
    "data-testid": "desk-copy-link-button"
  }, React.createElement(CopyToClipboard, {
    value: urlToCopy
  }))), React.createElement(SocialMedia, {
    device: device,
    linkType: linkType,
    handleCopyLinkEvent: handleCopyLinkEvent,
    sectionSocial: sectionSocial,
    urlToCopy: urlToCopy
  }), React.createElement(SharedBag, {
    sectionSharedBag: sectionSharedBag,
    product: product,
    storeNumericId: channel == null ? void 0 : (_channel$data$ = channel.data[1]) == null ? void 0 : (_channel$data$$value = _channel$data$.value) == null ? void 0 : _channel$data$$value.id,
    cookieDomain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
    onAddToReadyBagEvent: handleAddToReadyBagEvent
  }));
};
process.env.NODE_ENV !== "production" ? ShareLinksContent.propTypes = {
  data: shape({
    product: shape({
      image: string,
      title: string
    })
  }),
  linkType: string.isRequired,
  shortenLink: shape({
    error: shape({
      status: number
    }),
    hasError: bool,
    isLoading: bool
  }).isRequired,
  staticProps: shape({
    device: string,
    sectionSharedBag: shape({
      buttonLabel: string,
      show: string,
      url: string
    }),
    sectionSocial: shape({
      buttons: arrayOf(shape({
        color: string,
        eventType: string,
        href: string,
        name: string
      })),
      title: string
    })
  }).isRequired,
  structure: shape({}),
  urlToCopy: string.isRequired
} : void 0;
ShareLinksContent.defaultProps = {
  data: {},
  structure: {}
};
export default withLayoutProps(ShareLinksContent);